(function () {
  'use strict';

  /* @ngdoc object
   * @name crewSignInScreen
   * @description
   *
   */
  angular
    .module('crewSignInScreen', [
      'ui.router'
    ]);
}());
